<template>
	<li class="dot-menu-item">
		<a href="#" class="dot-menu-item-inner" @click.prevent="onClick" @focusout="$parent.focusout" tabindex="0">
			<slot/>
		</a>
	</li>
</template>

<script>
export default {
	name: 'DotMenuItem',
	data() {
		return {
		}
	},
	methods: {
		onClick(e) {
			document.activeElement.blur();
			this.$emit('clicked', e);
		}
	}
}
</script>

<style scoped>
.dot-menu-item {
	margin-bottom: 0;
}

.dot-menu-item .dot-menu-item-inner {
	display: block;
	border: none;
	color: var(--primary_text_color) !important;
	background-color: transparent;
	text-align: left;
	margin: 0;
	padding: .8rem 2.4rem;
	outline-color: #bdbdbd;
	position: relative;
	overflow: hidden;
	font-size: 2.4rem;
	font-weight: 400;
	letter-spacing: 0;
	text-decoration: none;
	cursor: pointer;
	height: 6.4rem;
	line-height: 4.8rem;
	white-space: nowrap;
	min-width: 19.2rem;
}

.dot-menu-item .dot-menu-item-inner:hover,
.dot-menu-item .dot-menu-item-inner:focus {
	background-color: #eee;
}

.dot-menu-item .dot-menu-item-inner:active {
	background-color: #d9d9d9;
}

.dot-menu-item[disabled] .dot-menu-item-inner {
	color: #bdbdbd;
	background-color: transparent;
	cursor: auto;
	pointer-events: none;
}

.dot-menu-item.delete .dot-menu-item-inner {
	color: var(--error) !important;
}
</style>